import React from "react";
import { BranchDetails } from "../api";
import UserProfileCard from "./UserProfileCard";

interface Props {
    data: BranchDetails | null;
}

const BranchDetailsPanel: React.FC<Props> = ({ data }) => {
    if (!data) {
        return (
            <div className="h-full flex items-center justify-center text-gray-400">
                Select a branch to view details
            </div>
        );
    }

    const { branch, employees } = data;

    return (
        <div className="h-full flex flex-col overflow-hidden">
            <div className="pb-3 mb-3">
                <h2 className="text-lg font-semibold">{branch.ou_name}</h2>
                <p className="text-sm text-gray-600 mt-1">{branch.address}</p>
            </div>

            <div className="flex-1 min-h-0 overflow-y-auto hide-scrollbar space-y-4">
                {employees.map((emp, idx) => (
                    <UserProfileCard key={idx} employee={emp} />
                ))}
            </div>
        </div>
    );
};

export default BranchDetailsPanel;
